module.exports = __webpack_public_path__ + "27b7d2062b7923feeebad243fffaf4c5.jpg";